import { env } from '@/lib/env';

/*
 * Named API configuration surface + a `target` seam (spec §3.3).
 *
 * Today there is exactly ONE backend, so `apiConfig.targets.default` is the only
 * entry and it resolves to `env.API_BASE_URL`. The `ApiTarget` type and the
 * `target` parameter exist so a future multi-backend / BFF split (e.g. adding a
 * `reporting` or `bff` backend) is a matter of adding a target here and passing
 * its name at the call site — no change to the fetch wrapper's shape. This is a
 * behavior-preserving seam: with no `target` argument, callers get the single
 * current backend exactly as before.
 */
export type ApiTarget = 'default';

export const apiConfig = {
  /** The target used when a caller does not name one. */
  defaultTarget: 'default' as ApiTarget,
  /** Base URL per backend target. Add entries here to split backends. */
  targets: {
    default: env.API_BASE_URL,
  } satisfies Record<ApiTarget, string>,
} as const;

/**
 * Resolve the (possibly relative) base URL for a backend target. `baseUrl` stays
 * relative in the browser; the per-request base-url middleware absolutizes it.
 */
export function apiBaseUrl(
  target: ApiTarget = apiConfig.defaultTarget,
): string {
  return apiConfig.targets[target];
}
